import { parseJwt } from '@/utils/tokenParser';
import _ from 'lodash';

export const AUTH0_SCOPES = {
  ALL_AUTH0_SCOPES: import.meta.env.VITE_ALL_AUTH0_SCOPES?.split(','),
  ADMIN_SCOPES: import.meta.env.VITE_ADMIN_SCOPES?.split(','),
  MANAGER_SCOPES: import.meta.env.VITE_MANAGER_SCOPES?.split(','),
  SUPPORT_SCOPES: import.meta.env.VITE_SUPPORT_SCOPES?.split(','),
  HUB_ACCESS_SCOPES: import.meta.env.VITE_VDI_HUB_ACCESS?.split(','),
};

export const USER_PROPS = {
  CREATE_USER: 'Create User',
  USER_DETAIL: 'USER',
  EDIT_USER: 'EDIT USER',
  FIRST_NAME: {
    PLACEHOLDER: 'Enter First Name',
    LABEL: 'First Name',
  },
  LAST_NAME: {
    PLACEHOLDER: 'Enter Last Name',
    LABEL: 'Last Name',
  },
  EMAIL_ID: {
    PLACEHOLDER: 'Enter Email Id',
    LABEL: 'Email Id',
  },
  PASSWORD: {
    PLACEHOLDER: 'Enter Password',
    LABEL: 'Password',
  },
  ROLE: {
    PLACEHOLDER: 'Select Role',
    LABEL: 'Role',
  },
  BUTTON: {
    SAVE: 'SAVE',
    EDIT: 'UPDATE',
    WHILE_LOADING_IN_CREATION: 'CREATING USER...',
    WHILE_LOADING_IN_UPDATION: 'UPDATING USER...',
  },
  DISCLAIMER: {
    CANNOT_UPDATE_BOTH: 'Cannot Update Both Email and Password at once',
  },
};

export const USER_FORM_FIRST_NAME = 'firstName';
export const USER_FORM_LAST_NAME = 'lastName';
export const USER_FORM_EMAIL = 'email';
export const USER_FORM_PASSWORD = 'password';
export const USER_FORM_ROLE_NAME = 'roleName';

export const ROLES = {
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  SUPPORT: 'Support',
  USER: 'User',
  HUB_ACCESS: 'Hub-Access',
};

export const USER_CONSTANT_PROPS = {
  GENERIC: {
    CONFIRM: 'confirm',
    DELETE: 'delete',
    TOAST_TIME: 3000,
    DELAY: 1000,
    MIN_QUERY_LENGTH: 3,
  },
  VIEW_USER: {
    DELETE_MODAL: {
      TITLE: 'Delete User',
      DESCRIPTION_PREFIX: 'Are you sure you want to delete user: (',
      DESCRIPTION_SUFFIX: ')',
      PLACEHOLDER: 'please type `delete`',
      CANCEL: 'Cancel',
      CONFIRM_LABEL: 'Delete User',
    },
  },
  COLUMNS: {
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email',
    ROLE_NAME: 'Role Name',
    CREATED_ON: 'Created On',
    UPDATED_ON: 'Updated On',
    ACTION: 'Action',
  },
};
export const USER_PAGE_SEARCH_PLACEHOLDER_TEXT = 'Search';

export const decodeJwt = (token: string) => {
  const base64Payload = token.split('.')[1];
  const payload = decodeURIComponent(
    atob(base64Payload)
      .split('')
      .map(function (c) {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join(''),
  );
  return JSON.parse(payload);
};

export const getRole = (): string | undefined => {
  const TOKEN_FROM_LOCAL_STORAGE = localStorage.getItem('access_token');

  if (!TOKEN_FROM_LOCAL_STORAGE) return undefined;

  const permissions = parseJwt(TOKEN_FROM_LOCAL_STORAGE)?.permissions || [];

  const roleScopeMappings = [
    { role: ROLES.ADMIN, scopes: AUTH0_SCOPES.ADMIN_SCOPES },
    { role: ROLES.MANAGER, scopes: AUTH0_SCOPES.MANAGER_SCOPES },
    { role: ROLES.SUPPORT, scopes: AUTH0_SCOPES.SUPPORT_SCOPES },
    { role: ROLES.HUB_ACCESS, scopes: AUTH0_SCOPES.HUB_ACCESS_SCOPES },
  ];

  for (const { role, scopes } of roleScopeMappings) {
    if (scopes && scopes.every((perm: string) => permissions.includes(perm))) {
      return role;
    }
  }
  return ROLES.USER;
};
